// router item keys
export enum RouterStoreItemKey {
    HELLO_WORLD = "HELLO_WORLD",
    LOGIN = "LOGIN",
    LISTITEMS = "LISTITEMS",
    RELEASECARD = "RELEASECARD",
    STOCKINGCARD = "STOCKINGCARD",
    STOCKINGDEICINGCARD = "STOCKINGDEICINGCARD",
    DEICINGCARD = "DEICINGCARD",
    DEICINGCARDTECH = "DEICINGCARDTECH",
    DEICINGCHECKCARD = "DEICINGCHECKCARD",
    DEICINGLIST = "DEICINGLIST",
    INVENTORY = "INVENTORY",
    INVENTORYDEICE = "INVENTORYDEICE",
    NOTRETURNEDCARD = "NOTRETURNEDCARD",
    HISTORYITEMS = "HISTORYITEMS",
    HISTORYITEMSODMRAZ = "HISTORYITEMSODMRAZ",
    CHANGEPASSWORD = "CHANGEPASSWORD",
    SELECTMODULE = "SELECTMODULE",
    SELECTROLE = "SELECTROLE"
}

// router item
export interface RouterStoreItem {
    active: boolean; // is this the active route (currently displayed) ?
    uid: string; // unique identifier for this router item (should be UUID v7)
    key: RouterStoreItemKey; // key of the router item
    data: any; // optional dynamic data associated with this router item
}

export interface RouterStoreData {
    // routing history
    history: RouterStoreItem[];
}

export interface RouterStore extends RouterStoreData {

    // navigate to a new router item
    go: (item: Partial<RouterStoreItem>) => Promise<void>;

    // go back to the previous router item
    back: () => Promise<void>;

    // clear the router history
    clear: () => Promise<void>;

    // set data for a specific router item
    setData: (uid: string, data: any) => Promise<void>;
}